import { render, staticRenderFns } from "./MatchAverage.vue?vue&type=template&id=3993a36e&scoped=true&"
import script from "./MatchAverage.vue?vue&type=script&lang=js&"
export * from "./MatchAverage.vue?vue&type=script&lang=js&"
import style0 from "./MatchAverage.vue?vue&type=style&index=0&id=3993a36e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3993a36e",
  null
  
)

export default component.exports